import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getProducts } from '../lib/api';
import PageHeader from '../components/common/PageHeader';

const CATEGORIES = [
  { id: 'all', name: 'Tüm Ürünler' },
  { id: 'deck', name: 'Deck' },
  { id: 'fence', name: 'Çit Sistemleri' },
  { id: 'garden_gate', name: 'Bahçe Kapı Sistemleri' },
  { id: 'facade', name: 'Cephe Sistemleri-Vinylbond' },
  { id: 'pergola', name: 'Pergola' },
  { id: 'baffle_ceiling', name: 'Baffle Tavan / Seperatör' },
  { id: 'flat_panel', name: 'Flat Paneller' },
];

const Products = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = searchParams.get('category');
  const selectedCategory = category && CATEGORIES.some((c) => c.id === category) ? category : 'all';

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getProducts({
          active: true,
          ...(selectedCategory !== 'all' ? { category: selectedCategory } : {}),
        });
        setProducts(data || []);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [selectedCategory]);

  const handleCategoryChange = (categoryId) => {
    if (categoryId === 'all') {
      navigate('/products');
      return;
    }

    navigate(`/products?category=${categoryId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Ürünlerimiz"
        description="Premium kalitede dış mekan çözümleri"
        backgroundImage="/images/hero-bg.jpg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8 flex flex-wrap justify-center gap-2">
          {CATEGORIES.map((item) => (
            <button
              key={item.id}
              onClick={() => handleCategoryChange(item.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                selectedCategory === item.id
                  ? 'bg-[#dbc582] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              {item.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#dbc582]"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {products.map((product) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="group relative bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <Link to={`/products/${product.slug}`}>
                  <div className="aspect-w-4 aspect-h-3 bg-gray-200 group-hover:opacity-75">
                    <img
                      src={product.main_image}
                      alt={product.title}
                      className="w-full h-full object-center object-cover"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-medium text-gray-900">{product.title}</h3>
                    <p className="mt-1 text-sm text-gray-500">{product.description}</p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}

        {!loading && products.length === 0 && (
          <div className="text-center mt-12">
            <h3 className="text-lg font-medium text-gray-900">
              Bu kategoride henüz ürün bulunmuyor
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              Lütfen başka bir kategori seçin veya daha sonra tekrar deneyin.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
